import { useContext } from 'react';
import SiteContext from './SiteContext';

const useSites = () => useContext(SiteContext);

export default useSites;
